import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { useUpdateProfileMutation } from '../favourites/UserApi';
import css from './VacationModeToggle.module.css';

/**
 * VacationModeToggle — enables/disables vacation mode for the current provider.
 *
 * Vacation mode is stored in currentUser.attributes.profile.publicData.vacationMode (boolean).
 * When enabled, an optional banner can be shown on the provider's listings.
 *
 * @param {Object} props.currentUser  — Sharetribe currentUser object
 * @param {string} [props.className]
 */
const VacationModeToggle = ({ currentUser, className }) => {
  const [updateProfile, { isLoading }] = useUpdateProfileMutation();

  const isVacationMode = !!currentUser?.attributes?.profile?.publicData?.vacationMode;

  const handleToggle = () => {
    updateProfile({
      publicData: { vacationMode: !isVacationMode },
    });
  };

  return (
    <div className={classNames(css.root, className)}>
      <div className={css.header}>
        <div className={css.info}>
          <h3 className={css.title}>
            <FormattedMessage id="VacationModeToggle.title" />
          </h3>
          <p className={css.description}>
            <FormattedMessage id="VacationModeToggle.description" />
          </p>
        </div>

        <button
          type="button"
          onClick={handleToggle}
          disabled={isLoading}
          className={classNames(css.toggle, { [css.toggleOn]: isVacationMode })}
          aria-pressed={isVacationMode}
          aria-label={isVacationMode
            ? 'Disable vacation mode'
            : 'Enable vacation mode'
          }
        >
          <span className={css.toggleThumb} />
        </button>
      </div>

      {isVacationMode && (
        <div className={css.activeNotice}>
          <span className={css.activeIcon}>🏖️</span>
          <FormattedMessage id="VacationModeToggle.activeNotice" />
        </div>
      )}
    </div>
  );
};

export default VacationModeToggle;
